<template>
  <div class="bordered">

    <div class="container-fill" @click="toggle">
      <div>{{ partner.name }}</div>
    </div>

    <div class="details" v-show="isActive">
      <div id="partnerButtons">
        <font-awesome-icon icon="trash" @click="deletePartner()" title="Delete partner"/>
      </div>
      
      <PartnerDetails :partner="partner"/>

      <br/>
      <b>Subscriptions:</b>
      <br/>
      <PartnerSubscriptions :partner="partner"/>

    </div>

    <pre class="debug" v-show="debugMode">{{ partner }}</pre>
  
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#partnerButtons {
  display: inline-block;
  float: right;
}
.default {
  font-size: small;
}
.container {
  display: flex;
}
.container-fill {
  display: flex;
  justify-content: space-between;
}
.details {
  margin-top: 5px;
  border-top: 1px solid #cccccc;
  padding-top: 5px;
}
.details-header {
  font-size: small;
}
.details-header > h2,h3,h4 {
  font-size: initial;
  margin: 0px;
}
</style>

<script>
import { mapState } from 'vuex'
import PartnerDetails from '@/components/PartnerDetails.vue'
import PartnerSubscriptions from '@/components/PartnerSubscriptions.vue'

export default {
  name: 'partner',
  components: {
    PartnerDetails,
    PartnerSubscriptions
  },
  props: {
    partner: {
      type: Object,
      required: true
    },
  },
  computed: mapState([
    'debugMode'
  ]),
  data () {
    return {
      isActive: false
    }
  },
  methods: {
    toggle: function (event) {
      if (event.target.tagName != 'DIV' && event.target.tagName != 'SPAN') return
      this.isActive = !this.isActive
    },
    deletePartner () {
      if (!confirm('Are you sure? This will delete the partner permanently!')) return
      this.$store.dispatch('deletePartner', this.partner)
    },
  }
}
</script>
